import { defineMessages } from "react-intl";

export const messages = defineMessages({
    filterPlaylists: {
        id: "vendor.settings.playlists-filter",
        defaultMessage: "Select a playlist",
    },
    snapshotTaken: {
        id: "vendor.settings.snapshot_taken",
        defaultMessage: "Snapshot taken on {date}",
    },
    goToTrack: {
        id: "vendor.settings.go_to_track",
        defaultMessage: "Go to track",
    },
    goToPlaylist: {
        id: "vendor.settings.go_to_playlist",
        defaultMessage: "Go to playlist",
    },
    noSnapshots: {
        id: "vendor.settings.no_snapshots",
        defaultMessage: "There are no snapshots to show.",
    },
    tracksOnPlaylists: {
        id: "vendor.title.tracks_on_playlists",
        defaultMessage: "Tracks currently on playlists",
    },
    // Playlist entity
    playlistDefaultTitle: {
        id: "vendor.playlist.default-title",
        defaultMessage: "Playlist {id}",
    },
    playlistEntitySingular: {
        id: "vendor.playlist.entity_singular",
        defaultMessage: "Playlist",
    },
    playlistEntityPlural: {
        id: "vendor.playlist.entity_plural",
        defaultMessage: "Playlists",
    },
    playlistEntityDefiniteArticle: {
        id: "vendor.playlist.entity_definite_article",
        defaultMessage: "the playlist",
    },
    playlistEntityDemonstrative: {
        id: "vendor.playlist.entity_demonstrative",
        defaultMessage: "this playlist",
    },
    playlistEntityIndefiniteArticle: {
        id: "vendor.playlist.entity_indefinite_article",
        defaultMessage: "a playlist",
    },
    playlistColumnMetaOwner: {
        id: "vendor.playlist.columns.meta.owner",
        defaultMessage: "Created by",
    },
    playlistListenOn: {
        id: "vendor.playlist.listen_on",
        defaultMessage: "Listen on {vendor}",
    },
    // Playlist Snapshot entity
    playlistSnapshotEntitySingular: {
        id: "vendor.playlist-snapshot.entity_singular",
        defaultMessage: "Playlist snapshot",
    },
    playlistSnapshotEntityPlural: {
        id: "vendor.playlist-snapshot.entity_plural",
        defaultMessage: "Playlist snapshots",
    },
    playlistSnapshotEntityDefiniteArticle: {
        id: "vendor.playlist-snapshot.entity_definite_article",
        defaultMessage: "the playlist snapshot",
    },
    playlistSnapshotEntityDemonstrative: {
        id: "vendor.playlist-snapshot.entity_demonstrative",
        defaultMessage: "this playlist snapshot",
    },
    playlistSnapshotEntityIndefiniteArticle: {
        id: "vendor.playlist-snapshot.entity_indefinite_article",
        defaultMessage: "a playlist snapshot",
    },
    playlistSnapshotColumnNumFollowers: {
        id: "vendor.playlist-snapshot.columns.num_followers",
        defaultMessage: "Number of followers",
    },
    playlistSnapshotColumnMetaUpdatedAt: {
        id: "vendor.playlist-snapshot.columns.meta.updated_at",
        defaultMessage: "Updated at",
    },
    playlistSnapshotColumnNumOwnedTracks: {
        id: "vendor.playlist-snapshot.columns.num_owned_tracks",
        defaultMessage: "Catalog tracks on playlist",
    },
    // Track entity
    trackEntitySingular: {
        id: "vendor.track.entity_singular",
        defaultMessage: "Track",
    },
    trackEntityPlural: {
        id: "vendor.track.entity_plural",
        defaultMessage: "Tracks",
    },
    trackEntityDefiniteArticle: {
        id: "vendor.track.entity_definite_article",
        defaultMessage: "the track",
    },
    trackEntityDemonstrative: {
        id: "vendor.track.entity_demonstrative",
        defaultMessage: "this track",
    },
    trackEntityIndefiniteArticle: {
        id: "vendor.track.entity_indefinite_article",
        defaultMessage: "a track",
    },
    trackColumnTitle: {
        id: "vendor.track.columns.title",
        defaultMessage: "Title",
    },
    trackColumnArtists: {
        id: "vendor.track.columns.artists",
        defaultMessage: "Artist(s)",
    },
    trackColumnAlbum: {
        id: "vendor.track.columns.album",
        defaultMessage: "Album",
    },
    trackColumnIsrc: {
        id: "vendor.track.columns.isrc",
        defaultMessage: "ISRC",
    },
    trackColumnVendor: {
        id: "vendor.track.columns.vendor",
        defaultMessage: "Service",
    },
    trackColumnPlaylists: {
        id: "vendor.track.columns.playlists",
        defaultMessage: "Playlists",
    },
    // Playlist Snapshot track pivot entity
    playlistSnapshotTrackColumnAddedAt: {
        id: "vendor.playlist-snapshot-track.columns.added_at",
        defaultMessage: "Added",
    },
});
